import CheckIcon from 'mdi-react/CheckIcon'
import CloseIcon from 'mdi-react/CloseIcon'

import { Translation } from '@/components/i18n/Translation'

import './polars.scss'

export const Yes = () => (
  <div className="polar__yes">
    <CheckIcon />
    <Translation id="Yes" />
  </div>
)

export const No = () => (
  <div className="polar__no">
    <CloseIcon />
    <Translation id="No" />
  </div>
)
